import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

import './index.less';

export const ContentLoader = () => {
    const antIcon = (
        <LoadingOutlined
            style={{ fontSize: 48 }}
            spin
        />
    );
    
    return (
        <div className="content_loader">
            <Spin indicator={antIcon} />
        </div>
    );
};
